<template>
	<div>
		<div class="img-wrap">
			<img :src="img" alt="">
		</div>
		<div class="txt">提交成功</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				img: require('../../assets/images/success.png')
			}
		}
	}
</script>

<style lang="less" scoped>
	.img-wrap {
		display: flex;
		justify-content: center;
		margin-top: 40%;

		img {
			width: 100px;
			height: 100px;
		}
	}

	.txt {
		display: flex;
		justify-content: center;
		margin-top: 20px;
		font-size: 18px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: rgba(51, 51, 51, 1);
		line-height: 25px;
	}
</style>
